/* eslint-disable no-console,no-undef, camelcase */
import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { getAllCompanies } from "../../../redux/actions/challengeActions";
import { withTranslation } from "react-i18next";
import { getSurveyLibraries } from "../../../redux/actions";
import { getCompanyLocation, getCompanyDepartment } from "../../../redux/actions";
import LaunchActivityChallenge from './launchChallenge';
import Waiting from '../../Waiting';
import _ from 'lodash';
import { fetchApi } from '../../../utils/methods';
import { toast } from 'react-toastify';
import { GetChallengeLibraryById } from '../../../redux/constants/apiConstants';

class LaunchActivityChallengeMain extends Component {
  constructor() {
    super();
    this.state = {
      editLibrary: '',
      challengeDetails: null,
      loading: true,
    };
  }

  getIdFromPath = () => {
    const { history } = this.props;
    const parts = history.location.pathname.split('/');
    return parts[parts.length - 1] || parts[parts.length - 2];
  };

  componentDidMount() {
    const { fetchAllCompanies, getSurveyLibraries, getCompanyLocation, getCompanyDepartment, companyDetails } = this.props;
    getSurveyLibraries();
    fetchAllCompanies();
    getCompanyLocation(companyDetails.id);
    getCompanyDepartment(companyDetails.id);
    this.fetchChallengeDetails();

    // const { getChallengeDetails, history } = this.props;
    // const StringArray = history.location.pathname.split('/');
    // if (StringArray[(StringArray.length - 1)] != '') {
    //   getChallengeDetails(StringArray[(StringArray.length - 1)]);
    // } else {
    //   getChallengeDetails(StringArray[(StringArray.length - 2)]);
    // }
  }

  componentDidUpdate(prevProps) {
    if (this.props.history.location.pathname !== prevProps.history.location.pathname) {
      this.fetchChallengeDetails();
    }

    // const { history, getChallengeDetails } = this.props;
    // const StringArray = history.location.pathname.split('/');
    // if (history.location.pathname !== prevProps.history.location.pathname) {
    //   if (StringArray[(StringArray.length - 1)] != '') {
    //     getChallengeDetails(StringArray[(StringArray.length - 1)]);
    //   } else {
    //     getChallengeDetails(StringArray[(StringArray.length - 2)]);
    //   }
    // }
  }

  fetchChallengeDetails = async () => {
    const id = this.getIdFromPath();
    this.setState({ loading: true });
    try {
      const res = await fetchApi(`${GetChallengeLibraryById}/${id}`, 'GET');
      if (res.statusCode === 200) {
        this.setState({ challengeDetails: res.data, loading: false });
      } else {
        toast.error(res.message);
        this.setState({ loading: false });
      }
    } catch(error) {
      toast.error(error.message);
      this.setState({ loading: false });
    }
  };

  render() {
    const { role, history, isAccountManager } = this.props;
    const { challengeDetails, loading } = this.state;
    if (loading || !challengeDetails || _.isEmpty(challengeDetails)) {
      return <Waiting />;
    }
    const isSurvivorChallenge = challengeDetails['challenge_type'] === 'survivor';
    const isGroupChallenge = challengeDetails['challenge_type'] === 'new_group';
    return (
      <LaunchActivityChallenge
        isSurvivorChallenge={isSurvivorChallenge}
        isGroupChallenge={isGroupChallenge}
        history={history}
        survivorChallengeData={challengeDetails}
        role={role}
        activityChallengeById={true}
        editLibrary={false}
        isAccountManager={isAccountManager}
      />
    );
  }
}

LaunchActivityChallengeMain.propTypes = {
  history: PropTypes.object.isRequired,
  role: PropTypes.string,
  fetchAllCompanies: PropTypes.func.isRequired,
  companyDetails: PropTypes.object,
  getSurveyLibraries: PropTypes.func,
  getCompanyLocation: PropTypes.func,
  getCompanyDepartment: PropTypes.func,
  isAccountManager: PropTypes.bool,
  t: PropTypes.func,
};

const mapStateToProps = (state) => ({
  allCompanies: state.challenges.allCompanies,
  userCompany: state.profileData.userCompany,
  locationDetails: state.register.locationDetails,
  companyDetails: state.profileData.companyDetails,
  userPermissions: state.profileData.userPermissions,
  surveyLibraries: state.surveys.surveyLibraries,
  // challengeDetails: state.challenges.activityDetailsById,
});

const mapDispatchToProps = (dispatch) => ({
  fetchAllCompanies: () => dispatch(getAllCompanies()),
  getSurveyLibraries: () => dispatch(getSurveyLibraries()),
  // getChallengeDetails: (id) => dispatch(getActivityChallengeById(id)),
  getCompanyLocation: (id) => dispatch(getCompanyLocation(id)),
  getCompanyDepartment: (id) => dispatch(getCompanyDepartment(id)),
});

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation()(LaunchActivityChallengeMain));
